// What a seller reads when Firebase turns down a sign-in, a sign-up or a password change. Firebase's own text
// ("Firebase: Error (auth/wrong-password).") is written for developers, so each code it can answer with is
// given a sentence here; a code not listed falls back to the caller's own sentence.

const WRONG_EMAIL_OR_PASSWORD = "That email or password isn't right. Try again, or click Forgot password.";

const MESSAGES = {
  'auth/user-not-found': 'No account found for this email. Check it, or create an account.',
  'auth/invalid-credential': WRONG_EMAIL_OR_PASSWORD,
  'auth/wrong-password': WRONG_EMAIL_OR_PASSWORD,
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/user-disabled': "This account can't be used right now. Email us at hello@voolist.com and we'll help.",
  'auth/too-many-requests': 'Too many tries in a row. Wait a few minutes, then try again.',
  'auth/network-request-failed': "Couldn't reach Voolist. Check your internet connection, then try again.",
  'auth/email-already-in-use': 'An account with this email already exists. Sign in instead.',
  'auth/weak-password': 'Use a password with at least 6 characters.',
  'auth/requires-recent-login': 'To keep your account safe, log out and log back in, then change your password.',
};

/**
 * @param {{ code?: string }} error - The error Firebase threw
 * @param {string} fallback - The sentence to show for a code not listed here
 * @returns {string}
 */
export function firebaseErrorMessage (error, fallback) {
  return MESSAGES[error?.code] || fallback;
}
